/**
 * RFC 9562 UUID (versions 1-8), matching the backend's `z.uuid()` constraint,
 * so an id accepted on the client is never one the backend would drop. Shared
 * by every first-party identity cookie validator (`_aid` in lib/auth0 and
 * `ph_anon_id` in lib/analytics) so they cannot drift apart.
 */
export const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
